exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-5f4777c5]{display:flex;flex-wrap:wrap;min-width:96%;padding:1.5em 2em;flex-direction:column;justify-content:left}.row[data-v-5f4777c5]{padding:.5em 1.5em;margin:.5em .75em;display:flex;flex:1 1 auto}.row h1[data-v-5f4777c5]{padding:0;color:#ff3232;font-size:3.5em;font-weight:500;margin:0 0 5px}.center[data-v-5f4777c5]{justify-content:center}.logo[data-v-5f4777c5]{display:flex;align-items:center;padding:0 1.5em}img[data-v-5f4777c5]{width:42vw;max-height:70px;min-width:200px;max-width:400px}.button[data-v-5f4777c5]{font-size:1.1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f4777c5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Sponsors.vue
// module id = 47
// module chunks = 0